import React, { useState, useEffect} from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Input from "@material-ui/core/Input";
import axios from "axios";
import Autocomplete from "@material-ui/lab/Autocomplete";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import UpdatePackageSalesUserRole from "./UpdatePackageSalesUserRole";
const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "600px",
		margin: "0 auto",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
		maxHeight:"100%",
		overflow: "auto"
	},
	root: {
		"& .MuiTextField-root": {
			width: "100%",
		},
	},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
	},
}));

export default function AddUserRole(props) {
	const {showModal} = props;
	const classes = useStyles();
	const [open, setOpen] = useState(false);
	const [modalData, setModalData] = useState([]);
	const [positionName, setPositionName] = useState('');
	//const [checkbox, setCheckbox] = useState(false);


	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleCheck = () => {
		//add logic later, for main nav ids,
		//setCheckbox(!checkbox);
	};

	const getUserRoleData = async() => {
		await axios.get(process.env.REACT_APP_API_URL+'add_user_role_data', {
			}).then(function (res) {
				setModalData(res.data.data);
		  	}).catch(function (error) {	
				console.log(error);
	  		});
	}

	useEffect(() => { //
		getUserRoleData();
	}, []);

	const removeDuplicates = (array) => {
		return [...new Set(array)];
	}

	// position:Postman Position
	// main_nav:1,2,3,4,5,6,7,8
	// content_nav:0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28
	// approval_role:[1,1,1,1] //hardcode for now
	const saveUserRole = async (position_name, main_nav, content_nav, ps_nav_data) => {
		if(position_name && main_nav && content_nav){
			const formData = new FormData();
			formData.append("position", position_name);
			formData.append("main_nav", main_nav);
			formData.append("content_nav", content_nav);
			formData.append("ps_nav_data", ps_nav_data);
			formData.append("approval_role", [1,1,1,1]); //hardcode for now
	
			await axios.post(process.env.REACT_APP_API_URL+'save_user_role', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
					}
				}).then(function (res) {
					showModal('Added new User Role '+ position_name, 'success');
					handleClose();
				  }).catch(function (error) {
					showModal('Something went wrong '+ error.message, 'warning');
					handleClose();
				  });
		}else{
			showModal('Something went wrong '+ 'Fields must not be empty', 'warning');
			handleClose();
		}
	}

	const handleSubmit = (e) => {
		e.preventDefault();

		//get all checked checkboxes / preparing content_nav
		const content_nav = Array.from(e.currentTarget.elements).filter(el => 
		(el.checked && el.getAttribute('type') === 'checkbox' && el.getAttribute('name').includes('ps') == false)).map(el => el.value);

		//get all checked checkboxes / preparing main_nav
		const main_nav_data = Array.from(e.currentTarget.elements).filter(el => 
		(el.checked && el.getAttribute('type') === 'checkbox' && el.getAttribute('name').includes('ps') == false)).map(el => el.name);
		
		//get all checked checkboxes / preparing package sales nav
		const ps_nav_data = Array.from(e.currentTarget.elements).filter(el => 
			(el.checked && el.getAttribute('type') === 'checkbox' && el.getAttribute('name').includes('ps'))).map(el => el.value);

		const main_nav = removeDuplicates(main_nav_data);
		//sort numbers in ascending order
		main_nav.sort = (a,b) => {
			return a-b;
		}
		content_nav.sort = (a,b) => {
			  return a-b;
		}
		ps_nav_data.sort = (a,b) => {
			return a-b;
	  	}
		saveUserRole(positionName, main_nav, content_nav, ps_nav_data);

    }

	return (
		<div>
			<Button variant="contained" color="primary" onClick={handleOpen} style ={{marginTop: "22px", marginLeft:"10px"}}>
				Add Role
			</Button>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={open}
				onClose={handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={open}>
					<div className={classes.paper}>
						<h4 id="transition-modal-title">Add User Role</h4>
						<form onSubmit={handleSubmit} className={classes.root}>
							<Grid container spacing={3}>
							<Grid item xs={12} xl={12}> 
								<Input style={{marginTop:  "21px"}} fullWidth={true} placeholder="Position" inputProps={{ 'aria-label': 'Position' }} onBlur={e => setPositionName(e.target.value)}/>
							</Grid>
							{modalData ? modalData.map((main_nav)=>{
								return(
									<React.Fragment key={main_nav.title+main_nav.length}>
									<Grid item xs={12} key={main_nav.title}>
										<h4>{main_nav.title}</h4>
									</Grid>	
										{main_nav.data.map((content_nav)=>{
											return(
												<Grid item xs={6} key={content_nav.id}>
												<FormControlLabel
													control={
													  <Checkbox
													    onChange={handleCheck}
														name={content_nav.cn_fkey}
														value={content_nav.id}
														color="primary"
													  />
													}
													label={content_nav.cn_name}
												  />
												</Grid>
											)
										})}
									</React.Fragment>
								)
							})
							: (<div></div>)}
							{/* <UpdatePackageSalesUserRole position_id={""}/> */}
								{/* <Grid item xs={12}>
									<h4>Inventory</h4>
								</Grid>
								<Grid item xs={9}>
									<FormControlLabel
      								  control={
      								    <Checkbox
      								    //   onChange={handleCheck}
      								      name="checkedB"
      								      color="primary"
      								    />
      								  }
      								  label="Inventory Adjustment"
      								/>
								</Grid> */}
							</Grid>
							<div className={classes.button}>
								<Button
									variant="contained"
									onClick={handleClose}
									className={classes.buttonMarginRight}
								>
									Close
								</Button>
								<Button type="submit" variant="contained" color="primary">
									Save
								</Button>
							</div>
						</form>
					</div>
				</Fade>
			</Modal>
		</div>
	);
}
